module.exports = __webpack_public_path__ + "static/egyptian-cotton-duvet-cover-dusty-rose-1-d293fd727cf0e1c934c0b2d8186485da.png";